import { MenuItem } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { selfServiceEventsURL } from '@/constants/self-service-dashboard-routes';
import { IUser } from '@/resources/upgrade/User';
import { AnyProfile } from '@/utils/profileHelpers';

export const DesktopUserMenuItems: FC<{
  user: IUser;
  currentUserProfile: AnyProfile;
  redirectUrl: string;
  onLogout: () => void;
}> = ({ user, currentUserProfile, redirectUrl, onLogout }) => {
  const { t } = useTranslation();

  if (!user) {
    return (
      <NextLink href={`/log-in?redirectUrl=${redirectUrl}`} passHref legacyBehavior>
        <MenuItem as="a"> {t('action.logIn')}</MenuItem>
      </NextLink>
    );
  }

  return (
    <Fragment>
      {currentUserProfile && (
        <NextLink href="/my-account/profile" passHref legacyBehavior>
          <MenuItem as="a">{t('action.myProfile')}</MenuItem>
        </NextLink>
      )}
      {user.isEventManager && (
        <MenuItem as="a" href={selfServiceEventsURL}>
          {t('action.myOrganizedEvents')}
        </MenuItem>
      )}
      <MenuItem onClick={onLogout}>{t('action.logOut')}</MenuItem>
    </Fragment>
  );
};
